<template>
    <div class="footer__legal-section">
        <div class="footer__legal-section--subtitle mb-5">{{ $t('age warning') }}</div>
        <div class="mb-5">{{ $t('disclaimer') }}</div>
        <ul class="link-list__items--horizontal">
            poland legal section
        </ul>
    </div>
</template>

<script>
    export default {
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/layout/footer/components/LegalSection.vue